import { PopconfirmProps } from "antd";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { StyledPopconfirm } from "./atom";

export type RenderbusPopconfirmProps = PropsWithChildren<
  PopconfirmProps & {
    popconfirmText?: string | JSX.Element;
    popType?: "link" | "other";
  }
>;
export function Popconfirm({
  children,
  popconfirmText,
  className = "",
  popType = "link",
  ...props
}: RenderbusPopconfirmProps) {
  const { t } = useTranslation("coupon");

  return (
    <StyledPopconfirm
      className={`renderbus-ui--popconfirm ${className}`}
      okText={t("coupon_modal_confirm_text")}
      cancelText={t("coupon_modal_cancel_text")}
      overlayClassName={`renderbus-ui--popconfirm ${className}`}
      {...props}
    >
      {popType === "link" ? <a href="#">{popconfirmText}</a> : children}
    </StyledPopconfirm>
  );
}
